import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import { PostTodoTask, PostTodoTitle } from "../../Controllers/Types/Todo/TodoInterface";
import apiClient from "../apiClient";

export const createTodoTitleApi = async (credentials : PostTodoTitle): Promise<CommonApiResponse> => {
    try {
        const response = await apiClient.post(`/api/todo-list/create`, credentials);
  
        if (response.status === 200 || response.status === 201) {
          return { status: true, massage: response.data };
        } else if (response.status === 422) {
          return { status: false, error: response.data['message'] };
        } else {
          return { status: false, error: 'Login failed' };
        }
    
      } catch (error: any) {
        return { status: false, error: 'An error occurred. Please try again later.' };
      }
}

export const getAllTodosWithTask = async () =>{
    try {
        const response = await apiClient.get(`/api/todo-list`);
        
        if (response.status === 200) {
          return { status: true, body: response.data };
        } else {
          return { status: false, error: 'failed' };
        }
  
      } catch (error: any) {
        // Handle error (display error message, log, etc.)
        return { status: false, error: 'An error occurred. Please try again later.' };
      }
  }

  export const updateTodoTitleApi = async (titleId : number, title : string , dueDate: string): Promise<CommonApiResponse> => {
    try {
      const data = {
        'title':title,
        'deu_date': dueDate
      };

        const response = await apiClient.put(`/api/todo-list/update/${titleId}`, data);
  
        if (response.status === 200 || response.status === 201) {
          return { status: true, massage: response.data };
        } else if (response.status === 422) {
          return { status: false, error: response.data['message'] };
        } else {
          return { status: false, error: 'Login failed' };
        }
    
      } catch (error: any) {
        return { status: false, error: 'An error occurred. Please try again later.' };
      }
  }

  export const deleteTodoTitleApi = async (titleId : number): Promise<CommonApiResponse> => {
    try {
     
  
        const response = await apiClient.delete(`/api/todo-list/delete/${titleId}`);
  
        if (response.status === 200 || response.status === 201) {
          return { status: true, massage: response.data };
        } else if (response.status === 422) {
          return { status: false, error: response.data['message'] };
        } else {
          return { status: false, error: 'Login failed' };
        }
    
      } catch (error: any) {
        return { status: false, error: 'An error occurred. Please try again later.' };
      }
  }


  export const createTodoTaskApi = async (credentials : PostTodoTask): Promise<CommonApiResponse> => {
    try {
        const response = await apiClient.post(`/api/todo-list-task/create`, credentials);
  
        if (response.status === 200 || response.status === 201) {
          return { status: true, massage: response.data };
        } else if (response.status === 422) {
          return { status: false, error: response.data['message'] };
        } else {
          return { status: false, error: 'Login failed' };
        }
    
      } catch (error: any) {
        return { status: false, error: 'An error occurred. Please try again later.' };
      }
}

export const updateTodoTaskApi = async (taskId : number, title : string): Promise<CommonApiResponse> => {
  try {
    const data = {
      'title':title,
    };

      const response = await apiClient.put(`/api/todo-list-task/update/${taskId}`, data);

      if (response.status === 200 || response.status === 201) {
        return { status: true, massage: response.data };
      } else if (response.status === 422) {
        return { status: false, error: response.data['message'] };
      } else {
        return { status: false, error: 'Login failed' };
      }
  
    } catch (error: any) {
      return { status: false, error: 'An error occurred. Please try again later.' };
    }
}

export const deleteTodoTaskApi = async (taskId : number): Promise<CommonApiResponse> => {
  try {
   

      const response = await apiClient.delete(`/api/todo-list-task/delete/${taskId}`);

      if (response.status === 200 || response.status === 201) {
        return { status: true, massage: response.data };
      } else if (response.status === 422) {
        return { status: false, error: response.data['message'] };
      } else {
        return { status: false, error: 'Login failed' };
      }
  
    } catch (error: any) {
      return { status: false, error: 'An error occurred. Please try again later.' };
    }
}

export const updateStatusTodoTaskApi = async (taskId : number): Promise<CommonApiResponse> => {
  try {
    const data = {
      
    };

      const response = await apiClient.post(`/api/todo-list-task/status-change/${taskId}`, data);

      if (response.status === 200 || response.status === 201) {
        return { status: true, massage: response.data };
      } else if (response.status === 422) {
        return { status: false, error: response.data['message'] };
      } else {
        return { status: false, error: 'Login failed' };
      }
  
    } catch (error: any) {
      return { status: false, error: 'An error occurred. Please try again later.' };
    }
}

